module.exports = __webpack_public_path__ + "img/IEC39855.65d64c56.svg";